// extracted by mini-css-extract-plugin
export default {"popover":"components-hotel-channel-pricing-edit-cell-popover-module__popover"};